import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AutoNotifyBaseComponent } from '../../../../shared-new/components/auto-notify-base/auto-notify-base.component';
import { StudyStatus } from '../../../../shared-new/enums/study-status.enum';
import { EventsEmitter } from '../../../../shared/event-emitter/EventEmitter';
import { NotificationTemplateComponent } from '../../../../shared/notification-template/notification-template.component';

@Component({
  selector: 'study-file-notification-modal',
  templateUrl: './study-file-notification-modal.component.html',
  styleUrls: ['./study-file-notification-modal.component.scss'],
})
export class StudyFileNotificationModalComponent extends AutoNotifyBaseComponent implements OnInit, AfterViewInit {

  

  @ViewChild('primaryRef', { static: false }) primaryRef!: NotificationTemplateComponent;

  
  @Input() studyFileId: number;
  @Input() data: any;


 
  form: FormGroup;

  constructor(public modal: NgbActiveModal, protected override readonly eventEmitter: EventsEmitter, private cd: ChangeDetectorRef) {
    super(eventEmitter);
  }

  ngAfterViewInit(): void {
    this.setNotificationTemplateRef(this.primaryRef);
  }

  ngOnInit(): void {
    
    this.messageTemplate = { ...this.data.notificationData.messageTemplate };
    // Approved/Denied go ONLY to the submitting vet's recipients (D-N2/D-N3). Vets who merely viewed the horse
    // are never an audience here: they get the separate "New Data Submitted" notification, never a denial.
    this.recipients = (this.data.notificationData.recipients || []).filter((r: any) => !r?.isViewingOnly);
    const selectedStatusId: number = StudyStatus.Denied;
    if (this.data.statusId == selectedStatusId) {
      this.form = new FormGroup({
        reason: new FormControl('', [Validators.required]),
      });
    } else {
      this.form = new FormGroup({
        reason: new FormControl('', []),
      });
    }

  }

  onSubmit(): void {
    this.changeViewModeToSubmit();
  }


  onCancel(): void {
    this.changeViewModeToSubmit();
  }




  UpdateStatus(): void {
    const reason = this.form.value.reason;
    this.data.notificationData.messageTemplate = { ...this.messageTemplate };
    this.data.notificationData.recipients = this.allChecked
      ? (this.getSelectedRecipients() || []).filter((r: any) => !r?.isViewingOnly)
      : [];
    this.modal.close({ reason, notificationData: this.data.notificationData });
  }
}
